import type { SystemStyleObject } from "@chakra-ui/react";

export const inputSizeOverrides: Record<string, SystemStyleObject> = {
  lg: {
    field: {
      borderRadius: 2,
    },
  },
  md: {
    field: {
      borderRadius: 2,
    },
  },
  sm: {
    field: {
      borderRadius: 2,
    },
  },
  xs: {
    field: {
      borderRadius: 2,
    },
  },
};
